import React from 'react';
import { Calendar, AlertCircle, Bell, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-charcoal pt-32 pb-40 px-6 lg:px-8 overflow-hidden min-h-[90vh] flex flex-col justify-center" data-id="element-133">
      {/* Background Video */}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-134">
        <source src="https://cdn.magicpatterns.com/uploads/rYQE36s9PagzYVcs5g1adp/32858-394513919_medium.mp4" type="video/mp4" data-id="element-135" />
      </video>

      {/* Refined Overlays: Lighter to show the video, darker at edges for text readability */}
      <div className="absolute inset-0 bg-charcoal/20" data-id="element-136"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-transparent to-charcoal/90" data-id="element-137"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-transparent to-transparent opacity-90" data-id="element-138"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-139">
        {/* Optimized Logo Container - Dark shadow to swallow white fringes and contrast to sharpen */}
        <div className="inline-block mb-8 transition-transform hover:scale-105 duration-300" data-id="element-140">
          <img src="https://cdn.magicpatterns.com/uploads/rTRsX2NVpzPv85SHwcDKzE/sylmar_logo_fondo_transparente_.2.png" alt="Sylmar Neighborhood Council - Logo Oficial" className="w-64 md:w-80 mx-auto drop-shadow-[0_0_15px_rgba(0,0,0,0.9)] contrast-125 saturate-110" style={{
          imageRendering: 'high-quality'
        }} data-id="element-141" />
        </div>

        {/* Enhanced Text Readability with Drop Shadows */}
        <h2 className="text-2xl md:text-3xl font-bold text-warm mb-4 tracking-wide drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-142">
          Concilio Vecinal de Sylmar / Sylmar Neighborhood Council
        </h2>

        <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6 drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)]" data-id="element-143">
          Tu comunidad necesita tu voz
        </h1>

        <p className="text-xl md:text-2xl text-softblue mb-12 leading-relaxed drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] font-medium max-w-3xl mx-auto" data-id="element-144">
          Encuentra reuniones, reporta problemas, participa en proyectos y
          mantente informado sobre lo que pasa en tu vecindario.
        </p>

        {/* Reorganized Buttons for better visual hierarchy */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 mb-4" data-id="element-145">
          <button className="flex items-center justify-center gap-2 bg-sky hover:bg-sky-dark text-white px-8 py-4 rounded-xl font-bold transition-all shadow-[0_4px_14px_0_rgba(74,173,228,0.39)] hover:shadow-[0_6px_20px_rgba(74,173,228,0.23)] hover:-translate-y-1" data-id="element-146">
            <Calendar className="w-5 h-5" data-id="element-147" />
            Ver próxima reunión
          </button>
          <button className="flex items-center justify-center gap-2 bg-warm hover:bg-warm-hover text-charcoal px-8 py-4 rounded-xl font-bold transition-all shadow-[0_4px_14px_0_rgba(249,231,159,0.39)] hover:shadow-[0_6px_20px_rgba(249,231,159,0.23)] hover:-translate-y-1" data-id="element-148">
            <AlertCircle className="w-5 h-5" data-id="element-149" />
            Reportar un problema
          </button>
        </div>

        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-150">
          <button className="flex items-center justify-center gap-2 bg-charcoal/40 backdrop-blur-md border border-white/30 text-white hover:bg-white hover:text-charcoal px-8 py-3 rounded-xl font-semibold transition-all" data-id="element-151">
            <Bell className="w-5 h-5" data-id="element-152" />
            Suscribirme a alertas
          </button>
          <button className="flex items-center justify-center gap-2 bg-charcoal/40 backdrop-blur-md border border-white/30 text-white hover:bg-white hover:text-charcoal px-8 py-3 rounded-xl font-semibold transition-all" data-id="element-153">
            <Users className="w-5 h-5" data-id="element-154" />
            Contactar al comité
          </button>
        </div>
      </div>
    </section>;
}